import classNames from 'classnames';
import React, { Component } from 'react';
import './styles.css';

/**
 * AccordionButton
 *
 * @typedef {Object} Props
 * @prop {boolean} [isOpen]
 *
 * @augments {Component<Props>}
 */

export default class AccordionButton extends Component {

genClassName = (props) =>
	classNames('AccordionButton', { AccordionButtonOpen: props.isOpen });

render () {
	const { isOpen } = this.props;
	return (
		<button className={this.genClassName(this.props)}>{isOpen}</button>
	);
}
}



// WEBPACK FOOTER //
// ./src/components/atoms/AccordionButton/AccordionButton.js